import React from 'react';
import { EventCategoryPage } from '../../components/Events/EventCategoryPage';
import { EVENT_CATEGORIES } from '../../data/eventCategoryData';
const LivestreamDiscussions = () => <EventCategoryPage config={EVENT_CATEGORIES['livestream-discussions']} data-id="element-9873" data-mp="3evo04iya4k4" />;
export default LivestreamDiscussions;